export function ClaimsKpiCard({ label, value, sub, subGreen, Icon }) {
  return (
    <div className="bg-white border border-slate-200 rounded-xl p-4 relative overflow-hidden">
      <div className="flex items-center gap-2 text-[11.5px] text-slate-500 font-medium">
        <Icon size={14} strokeWidth={1.75} />
        {label}
      </div>
      <div className="text-2xl font-semibold tracking-tight tabular-nums mt-1 text-slate-900">
        {value}
      </div>
      {sub && (
        <div className={`text-[11.5px] mt-0.5 ${subGreen ? 'text-emerald-600' : 'text-slate-500'}`}>
          {sub}
        </div>
      )}
    </div>
  );
}
